// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1WZ-b","selects":"Documents_selects__WCLKw"};